/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleALeftIcon16Regular = forwardRef('ArrowShapeTriangleALeftIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 4.158a1.25 1.25 0 0 0-1.919-1.056L4.016 6.944a1.25 1.25 0 0 0 0 2.112l6.065 3.841a1.25 1.25 0 0 0 1.92-1.056V4.158Zm-1.5.455v6.774L5.152 8 10.5 4.613Z" })));
});
